











































































import { Vue, Component } from "vue-property-decorator";
import { User } from "oidc-client";
import { $auth } from "@/services/AuthenticationService";

@Component
export default class Welcome extends Vue {
  ready = false;
  user: User | null = null;

  login() {
    // Redirects to authorization server with forced login prompt (to switch account)
    $auth.login({ prompt: "login" });
  }

  toGateway() {
    // Redirects to gateway page
    this.$router.push({ path: "/gateway" });
  }

  async removeAccount() {
    // Removes user account from login prompt
    await $auth.logout();
  }

  //created() {}

  async mounted() {
    if (this.$route.query.notify == "logout") {
      this.$notify({
        group: "main",
        type: "success",
        title: "Autenticación",
        text: "Se ha cerrado la sesión exitosamente.",
      });
    } else if (this.$route.query.notify == "error") {
      this.$notify({
        group: "main",
        type: "error",
        title: "Autenticación",
        text:
          "No fue posible iniciar la sesión. Si el problema persiste comuníquese con el administrador de la plataforma.",
      });
    }
    // Cleans any stale session from web storage
    await $auth.removeIdentity();
    // Performs silent login
    $auth
      .silentLogin()
      .then((user) => {
        this.user = user;
      })
      .catch((err) => {
        console.log(err);
        return;
      })
      .finally(() => {
        this.ready = true;
      });
  }
}
